import React from 'react';

import styles from './intelligenceSensorItem.module.scss'

const IntelligenceSensorItem = props => {
  const { title, value, measure } = props

  return (
    <div className={styles.intelligenceSensorItem}>
      <span className={styles.title}>{title}: </span>
      <span className={styles.value}>{value}</span>
      <span className={styles.value}>{measure}</span>
    </div>
  )
}

export default React.memo(IntelligenceSensorItem)